import React, { PureComponent } from 'react';
import { orderBy } from 'lodash';
import SectionTypeImage from './image';
import SectionTypeText from './text';
import SectionTypeList from './list';
import { IMAGES_REPO } from '../../config';
import { Gallery } from '../index';

export default class TypeSection extends PureComponent {

  getSectionsToDraw = ({ section_images = [], section_lists = [], section_texts = [] }) => {
    const sections = [];
    section_images.map((section) => {
      section._sectionType = 'Image';
      sections.push(section);
    });
    section_lists.map((section) => {
      section._sectionType = 'List';
      sections.push(section);
    });
    section_texts.map((section) => {
      section._sectionType = 'Text';
      sections.push(section);
    });
    return orderBy(sections, ['position'], ['asc']);
  };

  getImagesToGallery = ({ image, gallery }) => {
    const imgs = gallery ? JSON.parse(gallery) : [];
    const result = [
      {
        id: image,
        img: `${IMAGES_REPO}${image}`,
        caption: 'Fotografia by Planet',
        orientation: 'square',
        useForDemo: true
      }
    ];
    imgs.map((img, index) => {
      result.push({
        id: img,
        img: `${IMAGES_REPO}${img}`,
        caption: 'Fotografia by Planet',
        orientation: 'landscape',
        useForDemo: index < 5
      })
    });
    return result;
  };

  render() {
    const { values } = this.props;
    const sections = this.getSectionsToDraw(values);
    const galleryImages = this.getImagesToGallery(values);
    return (
      <div className="row">
        {
          sections.map((sectionObj, index) => {
            let Component;

            switch (sectionObj._sectionType) {
              case 'Image':
                Component = SectionTypeImage;
                break;
              case 'List':
                Component = SectionTypeList;
                break;
              case 'Text':
                Component = SectionTypeText;
                break;
              default:
                return () => (<div/>);
            }
            return (
              <div key={index} className="col-md-12 event-detail__section">
                <Component {...sectionObj}/>
              </div>
            );
          })
        }

        {
          galleryImages.length > 1 &&
          <div className="col-md-12 event-detail__section event-detail__section--gallery">
            <h2>Galeria</h2>
            <Gallery images={galleryImages.map(({ caption, id, img, orientation, useForDemo }) => ({
              src: img,
              thumbnail: img,
              caption,
              orientation,
              useForDemo,
            }))}/>
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/type-of-sections/TypeSection.js